import { Tooltip } from "@heroui/react";

export default function Name({
	name,
}: {
	name: string;
}) {
	return (
		<Tooltip content={name} delay={1000}>
			<p className="line-clamp-2 w-full text-sm">{name}</p>
		</Tooltip>
	);
}
